// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shadowedSeparatorCss_s158tbjp{height:8px;background-color:var(--gray02);}
`, "",{"version":3,"sources":["webpack://./node_modules/@fs/zion-footer/dist/es/FatFooter/Footer.css"],"names":[],"mappings":"AAAA,+BAA+B,UAAU,CAAC,8BAA8B,CAAC","sourcesContent":[".shadowedSeparatorCss_s158tbjp{height:8px;background-color:var(--gray02);}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
